import React from 'react'
import { DashboardLayout } from '../../layouts'
import {
  ListNav,
  ContentEmail,
  ContentPassword,
} from './components'

const DashboardSettings = () => {
  const [activeTab, setActiveTab] = React.useState('Email')
  const withNav = true

  return (
    <DashboardLayout
      title="Account Settings"
      mobileNav={withNav ? <ListNav activeTab={activeTab} onChange={setActiveTab}/> : undefined}
    >
      <div className="hidden xl:block">
        <h1 className="text-4xl font-bold font-primary mb-10">
          Account Settings
        </h1>
        <ListNav activeTab={activeTab} onChange={setActiveTab}/>
      </div>
      <div>
        { activeTab === 'Email' && <ContentEmail /> }
        { activeTab === 'Password' && <ContentPassword /> }
      </div>
    </DashboardLayout>
  )
}

export { DashboardSettings }
